import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

export const OverlayLoadingWrapper = styled.div`
	position: relative;
`

export const SpinnerWrapper = styled.div`
	position: absolute;
	top: 0;
	inset-inline-start: 0;
	z-index: 2;
	width: 100%;
	height: 100%;
	max-height: 400px;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const OverlayLoadingContent = styled.div<{ $isLoading?: boolean }>`
	position: relative;
	z-index: 1;

	${({ $isLoading }) =>
		$isLoading &&
		css`
			user-select: none;
			&::after {
				position: absolute;
				top: 0;
				inset-inline-end: 0;
				bottom: 0;
				inset-inline-start: 0;
				z-index: 10;
				width: 100%;
				height: 100%;
				background: ${theme.color.background.primary};
				opacity: 0.5;
				transition: all 0.3s;
				content: '';
			}
		`}
`
